import { SessionService } from './SessionService';
import {environment} from './../../environments/environment';
import {ErrorHandler} from './../common/error/error-handler';
import {Headers, Http, RequestOptions} from '@angular/http';
import {Injectable} from '@angular/core';

@Injectable()
export class DownloadExportService {
    private url: string;

    constructor(private http: Http, private session: SessionService) {
    }

    getExportFiles() {
        this.url = environment.api.myshiftUrl + '/exportpointage';
        const options = new RequestOptions({ headers: this.session.getHeaders() });
        return this.http.get(this.url, options)
        .map(response => response.json());
    }

    process(fileNames) {
        this.url = environment.api.myshiftUrl + '/downloadpointage';
        const options = new RequestOptions({ headers: this.session.getHeaders() });
        fileNames.forEach(fileName => {
            /*
            this.processFile(fileName, headers, options).subscribe(response => {
                this.downloadFile(response);
            });
            */
            window.open(this.url + '?fileName=' + fileName, '_blank');
        });
    }

    downloadFile(data: Response) {
        let blob = new Blob([data], { type: 'application/vnd.ms-excel' });
        let url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
    }

    processFile(fileName, headers, options) {
        /*
        return this.http.post(this.url, fileName, options)
        .map(response => response)
        .catch(ErrorHandler.handle);
        */
    }
}



// WEBPACK FOOTER //
// ./src/app/service/download-export.service.ts